<template>
    <div>
        <DataList :flag="'6cf8867a0b1df'" v-model="list" v-slot="{ item, index }">
            <div class="foo">
                {{ index + 1 }} - <DataText :flag="'1cc61480c7a4b'">{{ item.title }}</DataText>
            </div>
            <DataText :flag="'70ea18789a483'">{{ item.content }}</DataText>
        </DataList>
        <div class="bar">
            <DataText :flag="'2e816cbebeb99'">独立可编辑内容</DataText>
        </div>
    </div>
</template>
<script>
    export default {
        data: () => ({
            list: [{
                title: '7E基础功能包',
                content: '涵盖行情展示、技术分析图表、24小时资讯等行情功能，以及三键下单、画线下单、条件单、止损单、账号风控等交易功能... * 仅限使用wh7软件登录； * 本服务中必须提供的数据及信息仅限用户另外付费选配的范围；服务期内我司有权对其他数据及信息进行增、减等调整。'
            }, {
                title: '软件介绍',
                content: '高端的行情交易功能，针对机构和专业投资者。'
            }]
        })
    }
</script>
<style scoped>
    .bar {
        margin-top: 20px;
    }

    .foo {
        border-left: 4px solid #a02b00;
        height: 19px;
        line-height: 19px;
        font-size: 16px;
        color: #a02b00;
        font-weight: 700;
        padding-left: 8px !important;
        margin: 30px 0 6px 0;
    }
</style>